// extracted by mini-css-extract-plugin
export default {"loginButton":"FormsLoginComponent_loginButton__jrOPR","inputField":"FormsLoginComponent_inputField__ZB+Um"};